<div class="mb-1.5 flex flex-col gap-1">
  <label [for]="id()" class="mb-1 text-sm font-semibold text-gray-800">
    {{ label() }}
    @if (optional()) {
      <span
        class="ml-1 rounded-sm bg-gray-100 px-1.5 py-0.5 text-xs font-light whitespace-nowrap text-gray-700">
        optional
      </span>
    }
  </label>

  <textarea
    [id]="id()"
    [formControl]="control()"
    [placeholder]="placeholder()"
    [rows]="rows()"
    class="w-full resize-y rounded-lg border px-3 py-2 text-sm outline-none"
    [ngClass]="textareaClass()"></textarea>

  <span class="min-h-4 text-xs text-red-500">
    @if (showInvalid()) {
      {{ errorText() }}
    }
  </span>
</div>
